/* assets/faq.js — FAQ accordion + client-side pagination.
   Initializes every [data-faq] section on the page. */
(function () {
  function initFaq(s) {
    if (!s || s.dataset.faqInit === '1') return;
    s.dataset.faqInit = '1';

    var items = Array.prototype.slice.call(s.querySelectorAll('[data-faq-item]'));
    var per = parseInt(s.getAttribute('data-per-page'), 10) || 8;
    var pager = s.querySelector('[data-faq-pagination]');
    var pages = Math.ceil(items.length / per);
    var current = 0;

    items.forEach(function (item) {
      var trig = item.querySelector('[data-faq-trigger]');
      trig.addEventListener('click', function () {
        var open = item.classList.contains('is-open');
        items.forEach(function (i) {
          i.classList.remove('is-open');
          i.querySelector('[data-faq-trigger]').setAttribute('aria-expanded', 'false');
        });
        if (!open) { item.classList.add('is-open'); trig.setAttribute('aria-expanded', 'true'); }
      });
    });

    function showPage(p) {
      current = p;
      items.forEach(function (item, idx) {
        var onPage = Math.floor(idx / per) === p;
        item.style.display = onPage ? '' : 'none';
        if (!onPage) { item.classList.remove('is-open'); item.querySelector('[data-faq-trigger]').setAttribute('aria-expanded', 'false'); }
      });
      var first = items[p * per];
      if (first) { first.classList.add('is-open'); first.querySelector('[data-faq-trigger]').setAttribute('aria-expanded', 'true'); }
      buildPager();
      s.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function btn(label, page, opts) {
      opts = opts || {};
      var b = document.createElement('button');
      b.type = 'button'; b.setAttribute('data-faq-page', page); b.innerHTML = label;
      if (opts.active) b.classList.add('is-active');
      if (opts.disabled) b.disabled = true;
      else b.addEventListener('click', function () { showPage(page); });
      return b;
    }

    function buildPager() {
      if (!pager) return;
      if (pages <= 1) { pager.classList.add('hidden'); pager.innerHTML = ''; return; }
      pager.classList.remove('hidden');
      pager.innerHTML = '';
      pager.appendChild(btn('&#8249;', current - 1, { disabled: current === 0 }));
      for (var i = 0; i < pages; i++) { pager.appendChild(btn(String(i + 1), i, { active: i === current })); }
      pager.appendChild(btn('&#8250;', current + 1, { disabled: current === pages - 1 }));
    }

    showPage(0);
  }

  function initAll() { document.querySelectorAll('[data-faq]').forEach(initFaq); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
